<template>
  <a-layout class="nhf-app">
    <a-spin :spinning="lineLoading" :tip="tip">
      <a-layout-content class="nhf-editor">
        <a-row justify="space-between" type="flex" class="nhf-header">
          <h1 class="nhf-title" @click="goBack">
            <img class="nhf-logo" :src="logo" alt="返回上一页面" />
            <span class="newTextColor">{{ factoryName }}</span>
          </h1>
          <a-space>
            <a-tooltip>
              <template slot="title"> 全屏显示 </template>
              <a @click="full">
                <img v-if="!isFullScreen" :src="fullScreen" alt="全屏显示" />
                <img v-else :src="exitFullScreen" alt="退出全屏" />
              </a>
            </a-tooltip>
            <a-divider type="vertical" />
            <a-button @click="() => changeLinear({ key: 1 })" type="primary"
              :disabled="hasData || optimizeBtn">配方优化</a-button>
            <a-button @click="() => changeLinear({ key: 2 })" type="primary"
              :disabled="hasData || optimizeBtn">取整优化</a-button>
            <a-divider type="vertical" />
            <a-dropdown v-if="btn5DaysCal_0 || btn5DaysCal_1" :disabled="hasData">
              <a-button size="small" ghost type="primary">五日测算配方</a-button>
              <a-menu slot="overlay" @click="apply5DaysCalc">
                <a-menu-item v-if="btn5DaysCal_0" key="0" :disabled="btn5DaysCalDisabled">应用多配方优化结果</a-menu-item>
                <a-menu-item v-if="btn5DaysCal_1" key="1" :disabled="btn5DaysCalDisabled">应用执行版本产品</a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown :disabled="hasData">
              <a-button size="small" ghost type="primary">查看报表</a-button>
              <a-menu slot="overlay" @click="checkReport">
                <a-menu-item v-for="(item, index) in reportTypes" :key="index">{{ item }}</a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- <a-button ghost type="primary" :disabled="detail.isProduct == 0" size="small" @click="assessAction">原料评估</a-button> -->
            <a-dropdown :disabled="hasData">
              <a-button size="small" :loading="saveLoading" style="width: 84px" type="primary">保存</a-button>
              <a-menu slot="overlay" @click="saveFormula">
                <a-menu-item v-for="(item, index) in ['仅保存', '更新配方', '生成产品']" :key="index">{{ item }}</a-menu-item>
                <!-- <a-menu-item v-for="(item,index) in ['仅保存','更新配方']" :key="index">{{item}}</a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </a-space>
        </a-row>
        <div class="nhf-container" ref="editorContainer">
          <a-row type="flex" align="middle" class="nhf-header-main" justify="space-between">
            <a-space>
              <h3>{{ detail.taskName }}</h3>
              <a-icon size="small" style="font-size: 15px" @click="toggleEditorVisible" type="form" />
            </a-space>
            <a-row type="flex" align="middle" justify="space-between" style="padding: 0 20px">
              <div class="col">
                总价（元）
                <h2>
                  {{ total.totalPrice }}
                  <span v-if="total.diffTotalPrice != null" :style="{
                      color: total.diffTotalPrice > 0 ? 'red' : 'green',
                    }">
                    <template v-if="total.diffTotalPrice != '0.000'">
                      <b>/</b>{{ total.diffTotalPrice }}
                      <a-icon :type="
                          total.diffTotalPrice > 0 ? 'arrow-up' : 'arrow-down'
                        " />
                    </template>
                  </span>
                </h2>
              </div>
              <a-divider type="vertical" />
              <div class="col">
                总量（吨）
                <h2>
                  {{ total.totalAmount }}
                  <span v-if="total.diffTotalAmount != null" :style="{
                      color: total.diffTotalAmount > 0 ? 'red' : 'green',
                    }">
                    <template v-if="total.diffTotalAmount != '0.000'">
                      <b>/</b>{{ total.diffTotalAmount }}
                      <a-icon :type="
                          total.diffTotalAmount > 0 ? 'arrow-up' : 'arrow-down'
                        " />
                    </template>
                  </span>
                </h2>
              </div>
              <a-divider type="vertical" />
              <div class="col">
                均价（元/吨）
                <h2>
                  {{ total.avgPrice }}
                  <span v-if="total.diffAvgPrice != null" :style="{ color: total.diffAvgPrice > 0 ? 'red' : 'green' }">
                    <template v-if="total.diffAvgPrice != '0.000'">
                      <b>/</b>{{ total.diffAvgPrice }}
                      <a-icon :type="
                          total.diffAvgPrice > 0 ? 'arrow-up' : 'arrow-down'
                        " />
                    </template>
                  </span>
                </h2>
              </div>
            </a-row>
          </a-row>
          <div class="nhf-layout" ref="box">
            <div class="tableleft" :style="leftStyle" ref="left">
              <forumla-eidtor ref="formulaEditor" @refresh="refreshList" @showLoading="showLoading"
                @setList="setList" />
              <task-raw-detail ref="taskRawDetail" v-if="taskRaw.id" />
            </div>
            <div class="resize" ref="res" title="左右拖动调整宽度"></div>
            <div ref="right" :style="rightStyle" class="tableright">
              <task-raw-editor ref="taskRaw" @toggleHasAnalyse="toggleHasAnalyse" @updatePrice="updatePrice"
                @setList="setList" />
              <formula-detail ref="formulaDetail" v-if="formula.id" />
            </div>
          </div>
        </div>
      </a-layout-content>
      <vue-simple-context-menu :elementId="'layoutMenu'" :options="layoutOption" ref="contextMenuContainer"
        @option-clicked="menuChecked" />
      <formula-task-create :hidden="editorVisible" @ok="modifyTask" @cancel="toggleEditorVisible" :taskId="taskId" />
      <raw-assess-modal />
      <res-task-formula-modal />
      <res-task-product-modal />
      <analyse-modal :rawitem="rawRows" :hidden="analyseVisible" @close="toggleAnalyse" />
    </a-spin>
    <report-modal />
    <progress-modal @ok="refreshPage" :t="3000" />
  </a-layout>
</template>

<script>
import logo from '../../assets/images/logo_nhf.svg'
import fullScreen from '@/assets/images/icon/fullScreen.png'
import exitFullScreen from '@/assets/images/icon/exitFullScreen.png'
import FormulaTaskCreate from '../Nhf/Compound/modal/FormulaTaskCreate.vue'
import { formulaMixins } from './unitls'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import ForumlaEidtor from './editor/ForumlaEidtor.vue'
import TaskRawEditor from './editor/TaskRawEditor.vue'
import FormulaDetail from './modal/FormulaDetail.vue'
import TaskRawDetail from './modal/TaskRawDetail.vue'
import RawAssessModal from './modal/RawAssessModal.vue'
import ResTaskFormulaModal from './modal/ResTaskFormulaModal.vue'
import ResTaskProductModal from './modal/ResTaskProductModal.vue'
import AnalyseModal from "./modal/AnalyseModal.vue";
import ReportModal from './modal/ReportModal.vue'
import ProgressModal from './modal/ProgressModal.vue';

export default {
  components: { FormulaTaskCreate, VueSimpleContextMenu, ForumlaEidtor, FormulaDetail, TaskRawEditor, TaskRawDetail, RawAssessModal, ResTaskFormulaModal, ResTaskProductModal, AnalyseModal, ReportModal, ProgressModal },
  mixins: [formulaMixins],
  data() {
    return {
      optimizeBtn: false,
      tip: '',
      logo, fullScreen, exitFullScreen, // icon
      lineLoading: false,
      computedPrice: '0.00',
      saveLoading: false,
      editorVisible: false,
      halfWidth: null,
      factoryName: window.localStorage.getItem('factoryName'),  //工厂名称
      // hasData: false,
      formulaList: [],
      materialList: [],

      btn5DaysCal_0: false, // 五日测算配方-应用多配方优化结果按钮权限
      btn5DaysCal_1: false // 五日测算配方-应用执行版本产品按钮权限
    }
  },
  beforeDestroy() {
    this.setState({
      formulaSelectedRows: [],
      detail: {},
      height: 0,
      nutSelect: {},
      rawSelect: { rawName: "", percentage: 0 },
      rawRows: [],
      nutRows: [],
      rawResult: [],
      formula: {},
      taskRaw: {},
    })
  },
  created() {
    this.$nextTick(() => {
      this.getContainerHeight()
      this.dragControllerDiv()
      this.initSize()
      window.onresize = () => {
        this.initSize()
        this.getContainerHeight()
      }
    })
  },

  async mounted() {
    this.getDetail()
    this.getFactoryDetails()
    this.getBtn();
  },

  computed: {
    leftStyle() {
      return this.halfWidth ? {
        width: this.halfWidth + 'px'
      } : {}
    },
    rightStyle() {
      return this.halfWidth ? {
        width: this.halfWidth + 'px'
      } : {}
    },
    priceType() {
      return ''
    },
    layoutOption() {
      const { showSider, showRight, layoutType } = this.layout
      const item = [
        {
          type: 'divider'
        },
        {
          name: `<b>配方原料列表</b> ${showSider ? '<i />' : ''}`,
          commit: 'showSider'
        },
        {
          name: `<b>配方营养需要量</b> ${showRight ? '<i />' : ''}`,
          commit: 'showRight'
        }
      ]
      const base = [
        {
          name: `布局切换`,
          commit: 'layoutType'
        }
      ]
      return layoutType ? [...base, ...item] : base
    },
    total() {
      const { detail, priceString, diffString } = this
      const { totalAmount, totalPrice, avgPrice, lastTotalAmount, lastTotalPrice, lastAvgPrice, } = detail
      return {
        totalAmount: priceString(totalAmount),
        diffTotalAmount: diffString([totalAmount, lastTotalAmount]),
        totalPrice: priceString(totalPrice),
        diffTotalPrice: diffString([totalPrice, lastTotalPrice]),
        avgPrice: priceString(avgPrice),
        diffAvgPrice: diffString([avgPrice, lastAvgPrice]),
      }
    },
    hasData() {
      return this.formulaList.length === 0 || this.materialList.length === 0
    },
    btn5DaysCalDisabled() {
      // 【是否有效(五日测算)】== 否 || 【是否有效(五日测算) == NULL】，按钮无法点击；
      // 【当前时间】＞【截止时间(五日测算)】，按钮无法点击；
      const now = new Date();
      const endTime = new Date(this.detail.notifyEndTime);
      return this.detail.isEffective == null || this.detail.isEffective == false || now.getTime() > endTime.getTime();
    }
  },
  watch: {
    progressVisible(val) {
      if (!val) {
        this.lineLoading = false
      } else {
        this.lineLoading = true
      }
    },
  },
  methods: {
    refreshPage() {
      setTimeout(() => {
        this.$refs.formulaEditor && this.$refs.formulaEditor.getList && this.$refs.formulaEditor.getList(this.$refs.formulaEditor.pagination);
        this.$refs.taskRaw && this.$refs.taskRaw.getList && this.$refs.taskRaw.getList(this.$refs.taskRaw.pagination);
        if (this.$refs.formulaDetail && this.$refs.formulaDetail) {
          let detail = this.$refs.formulaDetail;
          detail.$refs.raw && detail.$refs.raw.getList && detail.$refs.raw.getList();
          detail.$refs.nutrition && detail.$refs.nutrition.getList && detail.$refs.nutrition.getList();
        }
        this.$refs.taskRawDetail && this.$refs.taskRawDetail.getList && this.$refs.taskRawDetail.getList();
      }, 100);
    },
    setList({ field, list }) {
      this[field] = list;
    },
    updatePrice() {
      this.$refs.formulaEditor && this.$refs.formulaEditor.getList && this.$refs.formulaEditor.getList(this.$refs.formulaEditor.pagination);
    },
    showLoading() {
      this.tip = '配方同步中，请耐心等待';
      this.lineLoading = !this.lineLoading;
    },
    refreshList() {
      this.$refs.taskRaw && this.$refs.taskRaw.getList(this.$refs.taskRaw.pagination);
    },
    getFactoryDetails() {
      let id = window.localStorage.getItem('factoryId');
      if (!id) {
        this.$get('/iot-factory/factory/detail', { id }).then(res => {
          let { success, data } = res || {};
          if (success) {
            let { overseasFlag } = data || {};
            this.overseasFlag = overseasFlag;
            if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
              window.localStorage.setItem('overseasFlag', overseasFlag);
            }

            // 存一个工厂的详细信息
            window.localStorage.setItem('factoryDetail', JSON.stringify(data));
          }
        });
      }
    },
    toggleHasAnalyse(data) {
      this.setState({ rawRows: data });
      this.toggleAnalyse();
    },
    toggleAnalyse() {
      this.analyseVisible = !this.analyseVisible;
    },
    initSize() {
      if (this.$refs['box']) {
        const width = this.$refs['box'].offsetWidth;
        this.halfWidth = (width - 5) / 2;
      }
    },
    async saveFormula({ key }) {
      // const actions = [this.saveTaskFormula,this.updateTaskFormula,this.saveProduct]
      const actions = [this.saveTaskFormula, this.resTaskAction, this.resProcuctAction];
      if (key != 0) {
        const tips = ['配方保存中，请稍后', '配方更新中', '产品生成中，请稍后...'];
        this.tip = tips[key];
      }
      await actions[key]();
    },
    checkReport({ key }) {
      this.setState({ reportKey: key, reportVisible: true });
      // this.toggleVisible('reportVisible')
    },
    resTaskAction() {
      this.toggleVisible('resTask');
      // this.$confirm({
      //   title: '更新配方',
      //   content: '将多配方中的配方数据同步更新至单配方中，你还要继续吗？',
      //   cancelText:'取消',
      //   okText:'确定',
      //   onOk: ()=> {
      //     this.toggleVisible('resTask')
      //   },
      //   onCancel() {
      //   },
      // });
    },
    resProcuctAction() {
      let data = {
        taskId: this.taskId,
        factoryId: this.factoryId
      };
      this.$get("/nhf-app/formulataskraw/selectFormulaTaskRawState", data).then(
        (res) => {
          let { success, msg } = res;
          if (success) {
            this.toggleVisible('resProduct');
          } else {
            this.$confirm({
              title: '温馨提示',
              content: '全集原料的组分原料中包含失效原料，是否仍要生成产品？' + msg,
              cancelText: '取消',
              okText: '确定',
              onOk: () => {
                this.toggleVisible('resProduct');
              },
              onCancel() {
              },
            });
          }
        }
      );
    },
    async updateTaskFormula() {
      return this.fetchPost({
        actions: this.updateOrgFormula,
        data: { taskId: this.taskId },
        loading: 'lineLoading'
      });
    },
    saveTaskFormula() {
      this.$message.success('保存成功');
    },
    async saveProduct() {
      return this.fetchPost({
        actions: this.createFormulaProduct,
        data: { taskId: this.taskId },
        loading: 'lineLoading'
      });
    },
    assessAction() {
      if (this.isNoneLiner) {
        this.$message.warn('请先执行配方优化');
      } else {
        this.toggleVisible('assess');
      }
    },

    async changeLinear({ key }) {
      this.optimizeBtn = true;
      let { list: list1 } = this.$refs.formulaEditor || {};
      let { records: lst1 } = list1 || {};
      let { list: list2 } = this.$refs.taskRaw || {};
      let { records: lst2 } = list2 || {};
      let formulaDetail = this.$refs.formulaDetail || {};
      let tabSelect = formulaDetail.tabSelect;
      let { raw, nutrition } = formulaDetail.$refs || {};
      let { list: rawListObj } = raw || {};
      let { records: rawRecords } = rawListObj || {};
      let { list: nutritionListObj } = nutrition || {};
      let { records: nutritionRecords } = nutritionListObj || {};

      let estimateOutput = 0;
      let minValue = 0;
      lst1 && lst1.forEach(el => {
        estimateOutput += Number(el.estimateOutput || 0);
      });
      lst2 && lst2.forEach(el => {
        minValue += Number(el.minValue || 0);
      });
      let warnFlag = false;
      let gt = '>';
      let contentStr2 = '';
      let contentStr3 = '';
      let contentStr4 = '';
      let str2 = lst2 && lst2.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr2 += `全集原料:【${el.rawName}】的最小值 ${gt} 最大值;\r\n`;
          return <p>全集原料:【{el.rawName}】的最小值 {gt} 最大值;</p>;
        }
      });
      let str3 = rawRecords && rawRecords.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr3 += `配方原料:【${el.rawName}】的最小值 ${gt} 最大值;\r\n`;
          return <p>配方原料:【{el.rawName}】的最小值 {gt} 最大值;</p>;
        }
      });
      let str4 = nutritionRecords && nutritionRecords.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr4 += `营养需要量:【${el.name}】的最小值 ${gt} 最大值;\r\n`;
          return <p>营养需要量:【{el.name}】的最小值 {gt} 最大值;</p>;
        }
      });
      if (!this.formula.id) {
        str3 = null;
        contentStr3 = '';
        str4 = null;
        contentStr4 = '';
      } else {
        str2 = null;
        contentStr2 = '';
        if (tabSelect == 1) {
          str4 = null;
          contentStr4 = '';
        } else if (tabSelect == 2) {
          str3 = null;
          contentStr3 = '';
        }
      }
      setTimeout(() => {
        this.optimizeBtn = false;
      }, 0);
      if (warnFlag) {
        this.$confirm({
          icon: () => <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ffa600" />,
          title: '请注意',
          content: <div>{str2}{str3}{str4}</div>,
          cancelText: '返回修改',
          okText: '复制信息',
          width: 500,
          // duration: 0,
          onOk() {
            let random = contentStr2 + contentStr3 + contentStr4;
            const input = window.document.createElement('textarea');
            window.document.body.appendChild(input);
            input.innerHTML = random;
            // input.setAttribute('value',random);
            // input.select();
            input.setAttribute('code', 1);
            input.select();
            window.document.execCommand("Copy");

            var list = document.getElementsByTagName('textarea');
            var inputList = Array.prototype.slice.call(list);
            inputList.forEach((item) => {
              if (item.getAttribute('code')) document.body.removeChild(item);
            });
            this.$message.success('复制成功');
          },
          class: 'test',
        });
        return;
      }
      minValue = Number(minValue.toFixed(3));
      estimateOutput = Number(estimateOutput.toFixed(3));
      if (minValue > estimateOutput) {
        this.$confirm({
          title: '配方无解',
          content: <div>
            <span class='colorRed'>全集原料最小值总和为：{minValue}</span>，原料最小值大于预计生产量总和，请调整全集原料约束！
          </div>,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
          },
        });
        return;
      } else {
        this.setState({ progressModalUrl: '/formula/fivedaycalc?name=五日测算' });
        this.tip = '配方优化中，执行时间较长，请耐心等待...';
        this.fetchGet({
          data: {
            taskId: this.taskId,
            optimizationType: key,
          },
          loading: 'lineLoading',
          // actions:this.taskLinearOptimizationByOptimization,
          actions: this.asyncTaskLinearOptimizationByOptimization,
          showMessage: false,
        }).then(res => {
          if (res.success) {
            // this.$message.success(res.msg)
            this.setState({ progressType: true });
            this.getDetail();
            // this.formula && this.formula.id ? this.setState({resRaw:this.resRaw + 1,resNut:this.resNut + 1}) :  this.$refs['taskRaw'].getList(this.$refs['taskRaw'].pagination)
            // this.taskRaw && this.taskRaw.id ? this.$refs['taskRawDetail'].getList(this.$refs['taskRawDetail'].pagination) : this.$refs['formulaEditor'].getList(this.$refs['formulaEditor'].pagination)
          } else {
            this.$warning({
              title: '优化失败',
              content: res.msg,
              okText: '确定'
            });
          }
        });

      }

    },
    diffString(arg) {
      const [a, b] = arg;
      return a != null || b != null ? (a - b).toFixed(3) : null;
    },
    priceString(price) {
      return price === null || price === '' || price === undefined ? '---' : Number(price).toFixed(3);
    },

    modifyTask() {
      this.getDetail();
      this.setState({ resRaw: this.resRaw + 1 });
      this.toggleEditorVisible();
    },

    toggleEditorVisible() {
      this.editorVisible = !this.editorVisible;
    },

    getContainerHeight() {
      const boxHeight = this.$refs['editorContainer'] ? this.$refs['editorContainer'].offsetHeight : 900;
      const height = boxHeight - 200;
      this.editorContainerHeight = height;
      this.setState({ height });
    },

    menuChecked({ option }) {
      const { commit } = option;
      this.toggleLayout(commit);
    },

    goBack() {
      this.$router.back();
    },

    async getDetail() {
      if (this.$refs.taskRaw) this.$refs.taskRaw.rawCurrentType = 0;
      const res = await this.fetchGet({
        actions: this.formulataskDetail,
        name: 'details',
        data: {
          id: this.taskId,
        }
      });
      if (res && res.data) {
        if (this.progressType) {
          let progressPercent = 0;
          let percentObj = { 11: 20, 12: 40, 14: 60, 13: 80, 15: 100 };
          let msgObj = { 11: '数据组装中', 12: '算法准备计算', 13: '结果保存中', 14: '算法计算中', 15: '算法计算完成', 2: '多配方有解', 4: '多配方有解，存在不可行配方', 88: '多配方优化失败', 99: '多配方优化失败' };
          let { status } = res.data || {};
          if (status === 11 || status === 12 || status === 13 || status === 14) {
            progressPercent = percentObj[status];
            this.setState({
              progressVisible: true,
              progressModalTitle: '多配方优化中',
              progressModalBtnText: '退出任务管理',
              progressModalContent: msgObj[status] || '配方优化中',
              progressPercent,
            });
            setTimeout(() => {
              this.getDetail();
            }, 5000);
          } else {
            let field = '';
            let title = '';
            if (status === 2 || status === 4 || status === 88 || status === 99) {
              if (status === 2 || status === 4) {
                field = 'success';
                title = '多配方优化完成';
              } else if (status === 88 || status === 99) {
                field = 'warning';
                title = '多配方优化失败';
              }
              this[`$${field}`]({
                title,
                content: msgObj[status],
                okText: '知道了',
                onOk: () => {
                  this.setState({
                    progressType: undefined, progressVisible: false,
                    progressModalTitle: '',
                    progressModalBtnText: '',
                    progressModalContent: '',
                    progressPercent: 0,
                  });
                  this.refreshPage();
                }
              });
            }
            this.setState({
              progressVisible: false,
              progressModalTitle: '',
              progressModalBtnText: '',
              progressModalContent: '',
              progressPercent: 0,
            });
          }
        }
        this.setState({ detail: { ...res.data } });
        this.$refs.taskRaw.taskName = this.detail.taskName;
      }
    },

    dragControllerDiv() {
      const resize = document.getElementsByClassName('resize');
      const left = document.getElementsByClassName('tableleft');
      const mid = document.getElementsByClassName('tableright');
      const box = document.getElementsByClassName('nhf-layout');
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = e => {
          resize[i].style.background = '#e8e8e8';
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = e => {
            this.halfWidth = null;
            var endX = e.clientX;
            var moveLenght = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLenght < 400) moveLenght = 400; // 左边区域的最小宽度为32px
            if (moveLenght > maxT - 400) moveLenght = maxT - 400; //右边区域最小宽度为150px
            resize[i].style.left = moveLenght; // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLenght + 'px';
              mid[j].style.width = (box[i].clientWidth - moveLenght - 5) + 'px';
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = '#fff';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },

    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          this.testBtns = [];
          data && data.forEach(el => {
            if (el.path === '/formula/fivedaycalc') {
              el.children && el.children.forEach(item => {
                if (item.code === 'multiple-formula') this.btn5DaysCal_0 = true;
                if (item.code === 'exe-version') this.btn5DaysCal_1 = true;
              });
            }
          });
        }
      });
    },
    apply5DaysCalc({ key }) {
      const taskList = [
        {
          title: '应用多配方优化结果', color: '#F04134', class:'task-class', content: '确定应用多配方优化结果生成五日测算所需配方吗？', url: '/nhf-app/formulataskformula/applyAutoFormulaTaskCalResult'
        },
        { title: '应用执行版本产品', content: '确定应用产品记录中的执行版本配方生成五日测算所需配方吗？', url: '/nhf-app/formulataskformula/applyAutoFormulaTaskEBSExecResult' }
      ];
      const task = taskList[key];
      this.$confirm({
        icon:'exclamation-circle',
        title: task.title,
        content: (<p style={{ color: task.color }}>{task.content}</p>),
        cancelText: '取消',
        okText: '确定',
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.$get(task.url, { taskId: this.taskId }).then((res) => {
              if (res.success) {
                resolve();
                this.$message.success(res.msg);
              } else {
                reject();
                this.$message.error(res.msg);
              }
            }).catch(err => {
              reject();
              this.$message.error(err.data.msg);
            });
          })
        },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-tabs-bar {
  margin: 0 10px;
}

.nhf {
  &-container {
    border-radius: 5px;
    background: #fff;
    min-width: 800px;
    margin: 10px 20px 15px;
    height: calc(100vh - 60px);
    border-radius: 5px;
    background: #fff;
  }
}
/*
//   ::v-deep .ant-table-body::-webkit-scrollbar, ::v-deep.list-container::-webkit-scrollbar {
//     width : 4px;
//     height: 4px;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-thumb,::v-deep.list-container::-webkit-scrollbar-thumb {
//     border-radius: 0;
//     background   : #888;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-track,::v-deep.list-container::-webkit-scrollbar-track {
//     border-radius: 0;
//     background : #e8e8e8;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-corner {
//     background:#e8e8e8;
//   } */

.close-button {
  i {
    font-size: 15px;
    color: #444;
  }
}
.ant-tooltip-inner {
  font-size: 12px;
}
.vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;
  &--active {
    background: #fff;
    color: #444;
  }
  &__item {
    width: 180px;
    font-size: 13px;
    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      b {
        font-weight: normal;
      }
    }
    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }
    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}

.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}
.nhf-layout {
  display: flex;
  overflow: hidden;
  margin: 0;
  padding: 0;
  h2 {
    font-size: 14px;
    padding: 15px !important;
  }
}
.nhf-header {
  padding: 10px 20px 0;
}
.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.nhf-logo {
  // width:80px;
  height: 23px;
  margin-right: 8px;
}
.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}
.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}
.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  position: relative !important;
}
.ant-table-row-cell-break-word {
  position: relative !important;
}

.editor-container {
  flex: 1;
}
.col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  h2 {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 900;
    color: #444;
    span {
      &.red {
        color: red;
      }
      &.green {
        color: green;
      }
      b {
        color: #444;
        margin: 0 4px;
      }
    }
  }
}
.ant-layout-content {
  min-height: 100vh;
}
.appBox {
  height: inherit impor !important;
}

.resize {
  cursor: col-resize;
  width: 5px !important;
  height: calc(100vh - 118px);
  background-size: cover;
  background-position: center;
  position: relative;
  float: none;
  &:hover {
    color: #444444;
  }
  &:after {
    border: 1px solid #888;
    left: -1px;
    right: -1px;
    border-top: none;
    border-bottom: none;
    height: 20px;
    content: "";
    margin-top: -10px;
    position: absolute;
    top: 50%;
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 2px;
    background-color: #e8e8e8;
    width: 1px;
  }
}
.tableleft,
.tableright {
  position: relative;
}
.colorRed {
  color: red;
}
</style>
